import { defineComponent as _defineComponent } from 'vue'
import { Course, CourseForm } from '@/entities/trainings';
  import { useModal } from '@/ui/concerns/modals/useModal';
  import CreateCourseModal from '@/ui/components/trainings/courses/CreateCourseModal.vue';
  import { useCourseBuilderStore } from '@/stores/trainings/courseBuilder';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'CourseDetails',
  props: {
    course: {
      type: Object as () => Course,
      required: true,
    },
  },
  setup(__props) {

const { course } = __props;

  

  const [isModalOpen, openModal, closeModal] = useModal();
  const courseBuilderStore = useCourseBuilderStore();

  const handleUpdated = (updatedCourse: CourseForm) => {
    courseBuilderStore.updateCourseDetails({
      ...course,
      ...updatedCourse,
    });
    closeModal();
  };

return { __sfc: true,isModalOpen, openModal, closeModal, courseBuilderStore, handleUpdated, CreateCourseModal }
}

})